// DS: i12.8
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Applications: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M9.2041 13.0107C10.2128 13.113 11 13.9643 11 15V19C11 20.1046 10.1046 21 9 21H5C3.96435 21 3.113 20.2128 3.01074 19.2041L3 19V15C3 13.8954 3.89543 13 5 13H9L9.2041 13.0107ZM19.2041 13.0107C20.2128 13.113 21 13.9643 21 15V19C21 20.1046 20.1046 21 19 21H15C13.9643 21 13.113 20.2128 13.0107 19.2041L13 19V15C13 13.8954 13.8954 13 15 13H19L19.2041 13.0107ZM5 19H9V15H5V19ZM15 19H19V15H15V19ZM9.2041 3.01074C10.2128 3.113 11 3.96435 11 5V9C11 10.1046 10.1046 11 9 11H5C3.96435 11 3.113 10.2128 3.01074 9.2041L3 9V5C3 3.89543 3.89543 3 5 3H9L9.2041 3.01074ZM19.2041 3.01074C20.2128 3.113 21 3.96435 21 5V9C21 10.1046 20.1046 11 19 11H15C13.9643 11 13.113 10.2128 13.0107 9.2041L13 9V5C13 3.89543 13.8954 3 15 3H19L19.2041 3.01074ZM5 9H9V5H5V9ZM15 9H19V5H15V9Z" />
      </svg>
    </IconWrap>
  );
};
Applications.displayName = 'Applications';

export default Applications;
